export default __webpack_public_path__ + "static/media/textileinsights.6fbb3a4a.png";